var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdmin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.9247 37.3133C67.9247 54.0654 54.3634 67.527 37.711 67.527C20.9589 67.527 7.49731 53.9657 7.49731 37.3133C7.49731 20.5612 21.0586 7.09961 37.711 7.09961C54.3634 7.09961 67.9247 20.5612 67.9247 37.3133Z",
    fill: "#E6DCFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8148 41.7681C43.8727 41.7681 48.7835 35.8751 48.7835 28.6058C48.7835 21.3364 43.8727 15.4434 37.8148 15.4434C31.757 15.4434 26.8462 21.3364 26.8462 28.6058C26.8462 35.8751 31.757 41.7681 37.8148 41.7681Z",
    fill: "#7701BF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3132 52.957C57.3388 49.0082 53.6095 45.7176 48.7833 43.7433C47.467 43.3045 45.9314 43.3045 44.8345 43.9627C42.6408 45.2789 40.4471 45.937 37.8146 45.937C35.1821 45.937 32.9884 45.2789 30.7947 43.9627C29.6978 43.5239 28.1622 43.3045 26.8459 43.9627C22.0197 45.937 18.2904 49.2276 16.316 53.1763C14.7804 56.0282 17.1935 59.3188 20.4841 59.3188H55.1451C58.4357 59.3188 60.8488 56.0282 59.3132 52.957Z",
    fill: "#7701BF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3984 72C56.7284 72 72.3984 56.33 72.3984 37C72.3984 17.67 56.7284 2 37.3984 2C18.0685 2 2.39844 17.67 2.39844 37C2.39844 56.33 18.0685 72 37.3984 72Z",
    stroke: "#982588",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/Admin.880c8e16b338843a67e26ee8ea2dabcd.svg";
export { ForwardRef as ReactComponent };